import { render, staticRenderFns } from "./recommend-product.vue?vue&type=template&id=0cc37785&scoped=true&"
import script from "./recommend-product.vue?vue&type=script&lang=js&"
export * from "./recommend-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc37785",
  null
  
)

export default component.exports